// extracted by mini-css-extract-plugin
module.exports = {"jobSearchList_plpLinkListArea":"jobSearchList_plpLinkListArea"};